import type { GraphEdge, GraphNode, WorkflowGraph } from '@nexus/skill-workflow';

import { END_NODE_ID } from '@nexus/skill-workflow';

export const START_NODE_ID = '__start';

export type CanvasNode = Omit<GraphNode, 'kind'> & { kind: GraphNode['kind'] | 'start' };
export type CanvasGraph = { nodes: CanvasNode[]; edges: GraphEdge[] };

export function toCanvasGraph(graph: WorkflowGraph): CanvasGraph {
  const endSteps = new Set(graph.nodes.filter((n) => n.stepType === 'flow.end').map((n) => n.id));
  const edges = graph.edges.filter((e) => !(e.target === END_NODE_ID && endSteps.has(e.source)));
  const nodes: CanvasNode[] = graph.nodes.filter(
    (n) => n.id !== END_NODE_ID || edges.some((e) => e.target === END_NODE_ID)
  );
  const first = graph.nodes.find((n) => n.kind === 'step' || n.kind === 'repeat');
  if (!first) return { nodes, edges };
  const start: CanvasNode = {
    id: START_NODE_ID,
    kind: 'start',
    parentId: null,
    title: 'Start',
    number: null,
    stepType: null,
    family: null,
  };
  const startEdge: GraphEdge = {
    id: `${START_NODE_ID}->${first.id}`,
    source: START_NODE_ID,
    target: first.id,
    kind: 'sequence',
    label: null,
  };
  return { nodes: [start, ...nodes], edges: [startEdge, ...edges] };
}
